import React from "react";
import logo from "../../Images/mindy_thumbsup_physician.png";
import logo_clipboard from "../../Images/mindy_thumbsup_patient.png";
import logo_clipboard2 from "../../Images/mindy_clipboard_physician 2.png";
import mindy_sitting_patient from "../../Images/mindy_sitting_patient.png";
import logo_clipboard5 from "../../Images/mindy_clipboard_physician 5.png";
import mindy_waving_admin from "../../Images/mindy_waving_admin.png";
import "./CurvedLinePhysician.css"; // Import the CSS file
import curved_line from "../../Images/Mask group.svg";

const CurvedLinePhysician = () => {
  return (
    <>
      <div className="curved-line-container">
        <div className="large-screen-layout">
          <img
            src={curved_line}
            alt="Curved Line"
            style={{
              position: "relative",
              width: "80%",
              height: "45%",
              left: "10%",
              top: "10vh",
            }}
          />

          <img
            src={logo}
            alt="Mascot"
            style={{
              position: "absolute",
              left: "20%",
              // top: "40%",
              width: "15vw",
              height: "30vh",
              zIndex: 1,
            }}
          />
          <div
            style={{
              position: "absolute",
              width: "80vw",
              height: "35vh",
              right: "60vw",
              // top: "0%",
            }}
          >
            <h3
              style={{
                position: "absolute",
                width: "100%",
                height: "auto",
                left: "60%",
                top: "70%",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontStyle: "italic",
                fontWeight: "400",
                fontSize: "var(--font-size-5xl)",
                // lineHeight: "4vh",
                display: "flex",
                alignItems: "center",
                color: "rgba(102, 102, 102, 0.9)",
                margin: "0",
              }}
            >
              Enhanced Efficiency
            </h3>
            <p
              style={{
                position: "absolute",
                width: "40%",
                height: "auto",
                left: "60%",
                top: "90%",
                fontFamily: "Lato",
                fontStyle: "italic",
                fontWeight: "300",
                fontSize: "var(--font-size-2xl)",
                // lineHeight: "3vh",
                display: "flex",
                alignItems: "center",
                color: "rgba(102, 102, 102, 0.6)",
                margin: "0",
                zIndex: "10",
              }}
            >
              Simplify your workflow with streamlined tools for managing
              patients, viewing scans, and sharing data with your team, saving
              time and enhancing productivity and quality of care.
            </p>
          </div>
          <img
            src={logo_clipboard2}
            alt="Mascot"
            style={{
              position: "absolute",
              width: "15%",
              height: "25vh",
              left: "55%",
              // top: "5%",
              zIndex: 1,
              top: "42%",
            }}
          />
          <div
            className="Analytics"
            style={{
              position: "absolute",
              // width: "80vw",
              // height: "35vh",
              // right: "60vw",
              zIndex: "0",
              top: "40%",
            }}
          >
            <div
              className="Rectangle"
              style={{
                position: "absolute",
                width: "80vw",
                height: "50vh",
                left: "50vw",
                top: "30vh",
                background: "rgba(163, 226, 215, 0.25)",
                borderRadius: "7.5vh 0px 0px 7.5vh",
                zIndex: "0",
              }}
            >
              <h3
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "auto",
                  left: "5%",
                  top: "20%",
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontStyle: "italic",
                  fontWeight: "400",
                  fontSize: "var(--font-size-5xl)",
                  // lineHeight: "4vh",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(102, 102, 102, 0.9)",
                  margin: "0",
                }}
              >
                Centralized Patient Data
              </h3>
              <p
                style={{
                  position: "absolute",
                  width: "40%",
                  height: "auto",
                  left: "5%",
                  top: "35%",
                  fontFamily: "Lato",
                  fontStyle: "italic",
                  fontWeight: "300",
                  fontSize: "var(--font-size-2xl)",
                  // lineHeight: "3vh",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(102, 102, 102, 0.6)",
                  margin: "0",
                }}
              >
                Access all patient imaging and diagnostic records in one secure,
                organized location. Simplify access to critical information,
                reduce administrative tasks, and ensure accurate, efficient care
                delivery.
              </p>
            </div>
          </div>
          <img
            src={logo_clipboard}
            alt="Mascot"
            style={{
              position: "absolute",
              left: "20%",
              top: "60%",
              width: "15vw",
              height: "30vh",
              zIndex: "20",
            }}
          />
          <div
            className="Scheduling"
            style={{
              position: "absolute",
              width: "80vw",
              height: "300px",
              right: "20vw",
              top: "60%",
              left: "8%",
              // background: "rgba(163, 226, 215, 0.25)",
              borderRadius: " 0px 7.5vh 7.5vh 0px",
              zIndex: "0",
            }}
          >
            <h3
              style={{
                position: "absolute",
                width: "100%",
                height: "auto",
                left: "35%",
                top: "20%",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontStyle: "italic",
                fontWeight: "400",
                fontSize: "var(--font-size-5xl)",
                // lineHeight: "4vh",
                display: "flex",
                alignItems: "center",
                color: "rgba(102, 102, 102, 0.9)",
                margin: "0",
              }}
            >
              Anywhere, Anytime Access
            </h3>
            <p
              style={{
                position: "absolute",
                width: "30%",
                height: "auto",
                left: "35%",
                top: "35%",
                fontFamily: "Lato",
                fontStyle: "italic",
                fontWeight: "300",
                fontSize: "1vw",
                lineHeight: "3vh",
                alignItems: "center",
                color: "rgba(102, 102, 102, 0.6)",
              }}
            >
              Conveniently review patient scans on any device, whether you&apos;re at
              your desk, in the clinic, or on the move.
            </p>
          </div>

          <div className="Reimbursements">
            <div
              className="Rectangle"
              style={{
                position: "absolute",
                width: "100%",
                height: "40vh",
                left: "20vw",
                top: "78%",
                background: "rgba(163, 226, 215, 0.25)",
                borderRadius: "7.5vh 0px 0px 7.5vh",
                zIndex: "0",
              }}
            >
              <img
                src={mindy_sitting_patient}
                alt="Mascot"
                style={{
                  position: "absolute",
                  left: "55%",
                  width: "13vw",
                  height: "30vh",
                }}
              />
              <h3
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "auto",
                  left: "8%",
                  top: "15%",
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontStyle: "italic",
                  fontWeight: "10",
                  fontSize: "var(--font-size-5xl)",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(102, 102, 102, 0.9)",
                  margin: "0",
                }}
              >
                Realtime Updates
              </h3>
              <p
                style={{
                  position: "absolute",
                  width: "45%",
                  height: "auto",
                  left: "8%",
                  top: "25%",
                  fontFamily: "Lato",
                  fontStyle: "italic",
                  fontWeight: "300",
                  fontSize: "var(--font-size-2xl)",
                  display: "flex",
                  alignItems: "center",
                  margin: "0",
                  color: "rgba(102, 102, 102, 0.6)",
                }}
              >
                Never miss important updates—receive instant notifications for
                new imaging results or shared data, keeping you informed and
                ready to act.
              </p>
            </div>
          </div>

          <div className="Patient Management">
            <div
              className="Circle"
              style={{
                position: "absolute",
                width: "90vw",
                height: "90vw",
                left: "-30vw",
                top: "150vh",
                background: "rgba(163, 226, 215, 0.25)",
                borderRadius: "50%",
                zIndex: "0",
              }}
            />
          </div>
        </div>

        <div className="small-screen-layout">
          <div className="card">
            <img src={logo} alt="Mascot" className="card-image" />
            <h3 className="card-title">Accessible Care</h3>
            <p className="card-text">
              From the comfort of your home or anywhere you choose, physicians
              can connect seamlessly with their patients. Enjoy timely,
              personalized care, ensuring your health needs are met with ease
              and efficiency.
            </p>
          </div>

          <div className="card">
            <img src={logo_clipboard2} alt="Mascot" className="card-image" />
            <h3 className="card-title">Analytics</h3>
            <p className="card-text">
              Leverage powerful analytics to track patient progress and
              outcomes. Make informed decisions based on data-driven insights,
              ensuring better patient care and operational efficiency.
            </p>
          </div>

          <div className="card">
            <img src={logo_clipboard} alt="Mascot" className="card-image" />
            <h3 className="card-title">Scheduling</h3>
            <p className="card-text">
              Manage appointments with ease. Our intuitive scheduling tools
              ensure that your time is well-organized, reducing no-shows and
              maximizing efficiency.
            </p>
          </div>

          <div className="card">
            <img
              src={mindy_sitting_patient}
              alt="Mascot"
              className="card-image"
            />
            <h3 className="card-title">Reimbursements</h3>
            <p className="card-text">
              Streamline the reimbursement process, ensuring that you are
              compensated promptly and accurately for the care you provide.
              Focus on patient care, not paperwork.
            </p>
          </div>

          <div className="card">
            <img src={logo_clipboard5} alt="Mascot" className="card-image" />
            <h3 className="card-title">Patient Management</h3>
            <p className="card-text">
              From the comfort of your home or anywhere you choose, physicians
              can connect seamlessly with their patients. Enjoy timely,
              personalized care, ensuring your health needs are met with ease
              and efficiency.
            </p>
          </div>

          <div className="card">
            <img src={mindy_waving_admin} alt="Mascot" className="card-image" />
            <h3 className="card-title">Secure Compliance</h3>
            <p className="card-text">
              From the comfort of your home or anywhere you choose, physicians
              can connect seamlessly with their patients. Enjoy timely,
              personalized care, ensuring your health needs are met with ease
              and efficiency.
            </p>
          </div>
        </div>
      </div>
      <div className="WhoWeServe-container"></div>
    </>
  );
};

export default CurvedLinePhysician;
